<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-12">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Select Type:</h6>
                </label>
                <select class="form-select" v-model="compState.type">
                    <option v-for="trigger in typeList" :value="trigger.id">{{ trigger.name }}</option>
                </select>
                <textarea class="form-control mt-3" placeholder="Description" style="resize: none; height: 10rem;"
                    readonly :value="selectedTypeDescription"></textarea>
            </div>
        </div>
        <div class="col-12">
            <MultiBuy v-if="compState.type === '1'" />
            <FixedValue v-else-if="compState.type === '3'" />
            <PercentageOff v-else-if="compState.type === '4'" />
            <CheapestOneFree v-else-if="compState.type === '5'" />
            <DiscountAfterN v-else-if="compState.type === '6'" />
            <BuyXGetYFree v-else-if="compState.type === '7'" />
            <AmountOff v-else-if="compState.type === '8'" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { usePromotionStore, typeList } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

const MultiBuy = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/MultiBuy.vue'))
const FixedValue = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/FixedValue.vue'))
const PercentageOff = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/PercentageOff.vue'))
const CheapestOneFree = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/CheapestOneFree.vue'))
const DiscountAfterN = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/DiscountAfterN.vue'))
const BuyXGetYFree = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/BuyXGetYFree.vue'))
const AmountOff = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionType/AmountOff.vue'))

const promotionStore = usePromotionStore()

const compState = reactive({
    type: '',
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const selectedTypeDescription = computed(() => {
    return typeList.find(type => type.id === compState.type)?.description
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.type = tempActivePromotion.value.type.selectedType
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.type = promotion.type.selectedType
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        type: {
            ...tempActivePromotion.value.type,
            selectedType: newVal.type
        }
    } as Promotion)
}, { deep: true });

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>